import { Routes, Route } from 'react-router';

import { PageError } from '../../../layout';
import { AuthById } from '../AuthById';

import { Login } from './Login';
import { Register } from './Register';

export const OpenId = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path=":id">
        <Route path="*" element={<AuthById />} />
      </Route>
      <Route path="*" element={<PageError status={404} />} />
    </Routes>
  );
};
